import { Link } from "react-router-dom";
import { FileText, Download } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/components/Bits";

export default function Catalogos() {
  const { openQuote, categories } = useSite();
  return (
    <div>
      <PageHero eyebrow="Catálogos" title="Catálogo geral e fichas técnicas"
        subtitle="Apresentamos a Global Refrigeração como fabricante. Solicite o catálogo completo e as fichas dos equipamentos de seu interesse." />
      <div className="mx-auto max-w-[1400px] px-4 py-16 lg:px-8">
        <div className="mb-10 flex flex-col items-start justify-between gap-4 border border-[#27272A] bg-[#151618] p-8 md:flex-row md:items-center">
          <div className="flex items-center gap-4">
            <FileText className="h-10 w-10 text-[#FF5500]" />
            <div>
              <h3 className="font-heading text-xl font-bold text-white">Catálogo Geral Global Refrigeração</h3>
              <p className="text-sm text-[#A1A1AA]">Portfólio completo, linhas e capacidade de fabricação.</p>
            </div>
          </div>
          <Button data-testid="catalog-request-button" onClick={() => openQuote({ equipment_type: "Catálogo Geral", source: "catalogos" })}
            className="rounded-none bg-[#FF5500] px-6 py-5 font-bold hover:bg-[#CC4400]">
            <Download className="mr-2 h-4 w-4" /> Solicitar Catálogo
          </Button>
        </div>
        <div className="mb-10 -mt-6">
          <a href={`${API}/catalog.pdf`} target="_blank" rel="noopener noreferrer" data-testid="catalog-download-pdf" className="inline-flex items-center gap-2 text-sm font-semibold text-[#FF5500] hover:underline">
            <Download className="h-4 w-4" /> Baixar catálogo geral em PDF
          </a>
        </div>
        <h3 className="font-heading mb-4 text-lg font-bold text-white">Fichas por linha</h3>
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <button key={c.slug} data-testid={`catalog-sheet-${c.slug}`} onClick={() => openQuote({ equipment_type: c.name, source: "catalogos-ficha" })}
              className="flex items-center justify-between border border-[#27272A] bg-[#0A0A0B] p-5 text-left transition-colors duration-200 hover:border-[#FF5500]">
              <span className="text-sm font-medium text-white">{c.name}</span>
              <Download className="h-4 w-4 text-[#A1A1AA]" />
            </button>
          ))}
        </div>
        <p className="mt-8 text-xs text-[#71717A]">Fichas técnicas com valores validados são enviadas após a solicitação. Nenhuma especificação é publicada sem validação.</p>

        <Link to="/projetos-especiais" data-testid="catalog-special-banner" className="mt-10 flex flex-col items-start justify-between gap-4 border border-[#FF5500] bg-[#151618] p-8 transition-colors duration-200 hover:bg-[#1E1F22] md:flex-row md:items-center">
          <div>
            <h3 className="font-heading text-xl font-bold text-white">Não encontrou o equipamento que precisa?</h3>
            <p className="mt-1 text-sm text-[#A1A1AA]">Envie sua necessidade com fotos e desenhos — projetamos e fabricamos sob medida.</p>
          </div>
          <span className="shrink-0 bg-[#FF5500] px-6 py-3 font-bold text-white">Enviar meu projeto</span>
        </Link>
      </div>
    </div>
  );
}
